import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Header.css'; // Import the CSS file
import { CgMenu } from "react-icons/cg";
import { FaArrowRight } from "react-icons/fa6";
import { FaFont } from "react-icons/fa6";

const Header = ({ toggleMenu, handleShare, handleIncreaseFontSize, handleDecreaseFontSize, transparent }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isArticlePage = location.pathname.startsWith('/article');
  const isVideoPage = location.pathname.startsWith('/video');

  const handleBack = () => {
    navigate(-1); // Go back to the previous page
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header className={`header ${transparent ? 'transparent' : ''} ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        {(isArticlePage || isVideoPage) && (
          <div className="back-icon" onClick={handleBack}>
            <FaArrowRight /> {/* Right arrow symbol for back */}
          </div>
        )}
      
       
          <img 
            src={isScrolled ? "/images/logo.png" : "/images/logo-white.png"} 
            alt="Logo" 
            className="logo" 
          />
      
        
        {isArticlePage && (
          <div className="article-page-controls">
           
          </div>
        )}
         <div className="menu-icon" onClick={toggleMenu}>
        <CgMenu />
        </div>
      </div>
    </header>
  );
};

export default Header;
